import { motion, useInView } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useRef, useState, useEffect } from 'react';

const data = [
  { key: 'projects', value: 50, suffix: '+' },
  { key: 'satisfaction', value: 98, suffix: '%' },
  { key: 'countries', value: 12, suffix: '+' },
  { key: 'support', value: 24, suffix: 'h' },
];

const Counter = ({ target, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1500;
    const step = dur / target;
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= target) clearInterval(timer);
    }, step);
    return () => clearInterval(timer);
  }, [inView, target]);

  return <span ref={ref}>{count}{suffix}</span>;
};

const Stats = () => {
  const { t } = useTranslation();
  return (
    <section data-testid="stats-section" className="py-12 lg:py-16 bg-[#1A1816] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ top: '30%' }}
          animate={{ x: ['-10%', '10%'] }} transition={{ duration: 20, repeat: Infinity, ease: 'linear', repeatType: 'reverse' }}>
          <span className="text-[18vw] font-bold text-[#FAF8F5]/[0.02] tracking-[-0.05em] font-sans leading-none">
            RESULTS&nbsp;&nbsp;&nbsp;IMPACT&nbsp;&nbsp;&nbsp;RESULTS
          </span>
        </motion.div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {data.map((d, i) => (
            <motion.div key={d.key} className="text-center" data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
              <p className="text-3xl sm:text-4xl lg:text-5xl font-serif italic text-[#C9A96E]">
                <Counter target={d.value} suffix={d.suffix} />
              </p>
              <p className="mt-2 text-xs sm:text-sm text-[#FAF8F5]/50 tracking-wide">{t(`stats.${d.key}`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
